var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bean-source-page',{attrs:{"type":_vm.type,"columns":_vm.columns,"form-columns":_vm.formColumns,"filter-columns":_vm.filterColumns,"actions":_vm.actions,"action-column-props":{ width: 200 },"form":_vm.form,"title":_vm.$t(`model.options/${_vm.routeType}`),"resource":"options","onFetchData":_vm.onFetchData,"before-submit":_vm.beforeSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }